"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@phishtool/ui");
const Heading = (props) => (0, jsx_runtime_1.jsx)(ui_1.Heading, Object.assign({}, props, { letterSpacing: true }));
exports.Heading = Heading;
